import axiosInstance from "api/axiosInstance";
import SAlert from "components/Alert";
import { batch } from "react-redux";
import { monitorStockoutAction } from "./monitor-stockout-slice";
import exportAxiosInstance from "api/exportAxiosInstance";
import FileSaver from "file-saver";

// Get Monitor Stock Out
export const getMonitorStockOut =
  (params = {}) =>
  (dispatch) => {
    dispatch(monitorStockoutAction.setLoading(true));
    axiosInstance
      .get("/v1/get-monitor-stock-out", {
        params: params,
      })
      .then((response) => {
        if (response) {
          batch(() => {
            dispatch(monitorStockoutAction.setError(null));
            dispatch(monitorStockoutAction.setData(response.data));
            dispatch(monitorStockoutAction.setLoading(false));
          });
        }
      })
      .catch((error) => {
        dispatch(monitorStockoutAction.setLoading(false));
        console.log(error);
      });
  };

// Export Monitor Stock Out

export const exportMonitorStockOut =
  (params = {}) =>
  (dispatch) => {
    dispatch(
      monitorStockoutAction.setExportStatus({
        loading: true,
        error: null,
      })
    );
    exportAxiosInstance
      .get("/v1/export-monitor-stock-out", {
        params: params,
      })
      .then((response) => {
        if (response) {
          const dataBlob = new Blob([response?.data], {
            type: "application/pdf,",
          });
          FileSaver.saveAs(
            dataBlob,
            `Monitor-Stockout-Report-${Math.random().toString()}.xlsx`
          );
          dispatch(
            monitorStockoutAction.setExportStatus({
              loading: false,
              error: null,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          monitorStockoutAction.setExportStatus({
            loading: false,
            error: error?.response?.data,
          })
        );
      });
  };

// Get Monitor Stock Out Count
export const getMonitorStockOutCount = () => (dispatch) => {
  axiosInstance
    .get("/v1/get-monitor-stock-out-count")
    .then((response) => {
      if (response) {
        dispatch(monitorStockoutAction.setCount(response?.data));
      }
    })
    .catch((error) => {
      dispatch(monitorStockoutAction.setCount(0));
      console.log(error);
    });
};
